// extracted by mini-css-extract-plugin
var _1 = "TableScrollButtonOverlay-moduleleftArrow__FYZzP TableScrollButton-moduleTableScrollButton__gpq2V";
var _2 = "TableScrollButtonOverlay-modulerightArrow__zL5Kx TableScrollButton-moduleTableScrollButton__gpq2V";
export { _1 as "leftArrow", _2 as "rightArrow" }
